// hook の叩き先を URL の引数で差し替える仕掛け（?wu_size_api= / ?wu_calendar_api= / ?wu_enquete_api= / ?wu_sample_form_api= / ?wu_estimate_api=）の判定（Issue #103）。
//
// ローカル検証（店のページの複製 + ローカルの API）のためのもの。**localhost / 127.0.0.1 だけ**受け、それ以外は無視して本番の口を使う。
// ★任意の URL を受けると、店の本物のドメインの上で、よそのサーバーから取った表示（納期・商品一覧・設問）を出す
//   リンクが作れてしまう（アンケートは回答と guid を他所へ送らせることもできた。#102 で見つけた）。

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1'])

/**
 * search（location.search）の param を見て、localhost / 127.0.0.1 の http(s) なら origin + pathname を返す。
 * 無い・形が崩れている・ほかのホストなら fallback（本番の口）。クエリ・ハッシュ・ユーザー情報は持ち込まない。
 */
export function resolveDevApiOverride(search: string, param: string, fallback: string): string {
  const override = new URLSearchParams(search).get(param)
  if (!override) return fallback
  try {
    const u = new URL(override)
    if ((u.protocol === 'http:' || u.protocol === 'https:') && LOCAL_HOSTS.has(u.hostname) && u.username === '' && u.password === '') {
      return `${u.origin}${u.pathname}`
    }
  } catch {
    // 形の崩れた URL（相対・スキーム無し）は無視
  }
  return fallback
}
